<template>
	<div class="cards-shipment-info">
		<div class="shipment-header">
			<h3>{{ getString('shipment_tracking') }}</h3>
		</div>
		<div class="shipment-content">
			<div class="status-row">
				<span class="label">{{ getString('status') }}:</span>
				<span class="value" :class="'status-' + shipmentStatus">{{ formatStatus(shipmentStatus) }}</span>
			</div>
			<div v-if="trackingUrl" class="tracking-row">
				<span class="label">{{ getString('tracking') }}:</span>
				<a :href="trackingUrl" target="_blank" class="tracking-link">
					{{ getString('track_shipment') }}
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="external-icon">
						<path d="M12 8.66667V12.6667C12 13.0203 11.8595 13.3594 11.6095 13.6095C11.3594 13.8595 11.0203 14 10.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V5.33333C2 4.97971 2.14048 4.64057 2.39052 4.39052C2.64057 4.14048 2.97971 4 3.33333 4H7.33333" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M10 2H14V6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
						<path d="M6.66797 9.33333L14.0013 2" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
					</svg>
				</a>
			</div>
			<div v-else-if="shipmentStatus === 'pending' || shipmentStatus === 'submitted'" class="info-message">
				{{ getString('card_being_prepared') }}
			</div>
		</div>
	</div>
</template>

<script>
import { useCardsStore } from "@/console-new/stores/cards.store";
import { useLanguageStore } from "@/shared/stores";

export default {
	name: "CardsShipmentInfo",
	setup() {
		const cardsStore = useCardsStore();
		const languageStore = useLanguageStore();
		return {
			cardsStore,
			languageStore
		}
	},
	computed: {
		activeCard() {
			if (!this.cardsStore.activeCardId || !this.cardsStore.businessCards) return null;
			return this.cardsStore.businessCards.find(card => card.card_id === this.cardsStore.activeCardId);
		},
		shipmentStatus() {
			return this.activeCard?.shipment_status || 'pending';
		},
		trackingUrl() {
			return this.activeCard?.shipment_tracking || null;
		}
	},
	methods: {
		formatStatus(status) {
			const statusMap = {
				'pending': this.languageStore.getString('status_pending'),
				'submitted': this.languageStore.getString('status_submitted'),
				'shipped': this.languageStore.getString('status_shipped'),
				'delivered': this.languageStore.getString('status_delivered'),
				'returned': this.languageStore.getString('status_returned'),
				'canceled': this.languageStore.getString('status_canceled'),
				'failure': this.languageStore.getString('status_failure')
			};
			return statusMap[status] || status;
		},
		getString(key) {
			return this.languageStore.getString(key);
		}
	}
};
</script>

<style scoped lang="scss">
.cards-shipment-info {
	background: var(--color-bg);
	border-radius: 13px;
	box-shadow: 0 2px 8px var(--color-border-1);
	padding: 24px;
	height: 100%;
	
	.shipment-header {
		margin-bottom: 24px;
		
		h3 {
			margin: 0;
			font-size: 18px;
			font-weight: 600;
			color: var(--color-txt);
		}
	}
	
	.shipment-content {
		.status-row,
		.tracking-row {
			display: flex;
			align-items: center;
			margin-bottom: 16px;
			
			.label {
				font-weight: 500;
				color: var(--color-txt-1);
				margin-right: 8px;
			}
			
			.value {
				font-weight: 600;
				
				&.status-pending,
				&.status-submitted {
					color: var(--color-warn);
				}
				
				&.status-shipped {
					color: var(--color-success);
				}
				
				&.status-delivered {
					color: var(--color-info);
				}
				
				&.status-returned,
				&.status-canceled,
				&.status-failure {
					color: var(--color-danger);
				}
			}
		}
		
		.tracking-link {
			display: inline-flex;
			align-items: center;
			gap: 8px;
			color: var(--color-primary);
			text-decoration: none;
			font-weight: 500;
			transition: opacity 0.2s;
			
			&:hover {
				opacity: 0.8;
			}
			
			.external-icon {
				flex-shrink: 0;
			}
		}
		
		.info-message {
			padding: 16px;
			background: var(--color-bg-primary-1);
			border-radius: 13px;
			color: var(--color-txt-1);
			font-size: 14px;
			line-height: 1.5;
		}
	}
}</style>